import React from 'react';
import { Link } from 'react-router-dom';
import '../../../CSS/Main/portfolio.scss';
// import '../../../CSS/main.scss';
// import PortfolioImage from '../../../Images'
import {ArrowRight} from 'react-feather';
const PortfolioContent = ({data})=> {
// console.log(data.image);
return (
<div className="container">
  {data && data.map((content)=>{
  return (
  <div key={content._id}>
    <div className="row">
      <div className="col-md-2 col-lg-2"></div>
      <div className="col-md-8 col-lg-8">
        <div className="contents">
          <div className="portfolio-image">
            <img src={content.image} alt="" width="100%" height="100%" />
          </div>
        </div>
      </div>
      <div className="col-md-2 col-lg-2"></div>
    </div>
    <div className="row">
      <div className="col-md-2 col-lg-2"></div>
      <div className="col-md-8 col-lg-8">
        <div className="project-stack">
          <h5 className="header_or_link">PROJECT NAME #<span> {content.projectname}</span></h5>
        </div>
      </div>
      <div className="col-md-2 col-lg-2"></div>
    </div>
    <div className="row mt-3">
      <div className="col-md-2 col-lg-2"></div>
      <div className="col-md-8 col-lg-8">
        <div className="project-stack">
          <h5 className="header_or_link">LIVE LINK <a href={content.livelink}
              className="header_or_link"><span>{content.livelink}</span></a></h5>
        </div>
      </div>
      <div className="col-md-2 col-lg-2"></div>
    </div>
    <div className="row mt-3 pt-4 pb-5">
      <div className="col-md-2 col-lg-2"></div>
      <div className="col-md-8 col-lg-8">
        <div className="project-link">
        <Link className="portfolio_link" to={`/main/portfolio/${content._id}`}>
              KNOW MORE
              <span><ArrowRight className="porfolio_arrow_icon"/></span>
        </Link>
        </div>
      </div>
      <div className="col-md-2 col-lg-2"></div>
    </div>
  </div>
  )
  })
  }
</div>

);
}

export default PortfolioContent;